module.exports = __webpack_public_path__ + "static/media/kpiticon.ab761b80.png";